import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useMemo,
  useCallback,
} from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Button,
  CircularProgress,
  IconButton,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Modal,
} from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { IoIosCloseCircleOutline } from "react-icons/io";
import axios from "axios";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import Cookies from "js-cookie";
import SearchResultBeforeLogin from "../viewActivityBeforeIn/SearchResultBeforeSignup";
import Feed from "../feed";
import PhotoPreview from "../../PhotoPreview";
import SayAskPost from "./sayAskPost";
import LeftSideBar from "src/pages/HomePage/components/LeftSideBar";
import useStyles from "../viewActivityBeforeIn/styles";
import API from "../../../network";
import layoutStyles from "./ViewActAfterSignIn.module.css";
import RightSideBar from "src/pages/HomePage/components/RightSideBar";
import RestrictionMsgModal from "src/Components/RestrictionMsgModal";
import { fetchloginUser } from "src/store/actions/SignInActions/SignInAction";
import TrendingAsks from "src/pages/HomePage/components/TrendingAsks";
import TrendingTags from "src/pages/HomePage/components/TrendingTags";
import SingleTrendingTag from "src/pages/HomePage/components/SingleTrendingTag";
import Page from "src/layout/Page";
import { isChildSayMessageType } from "src/Utils/commonUtils";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import UserAddSvg from "../../UserAddSvg";

const ViewActivitySignIn = () => {
  // const feedReducerData = useSelector((state) => state.feedReducer.feedData);
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
  const baseURL = process.env.REACT_APP_SERVICES_API_OTHER;
  const dispatch = useDispatch();
  const communityContext = useContext(CommunityContext);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);
  const {
    buttonContainer,
    shareUpdate,
    trending,
    seemore,
    feed,
    container,
    moderator,
    prospectimagesdiv,
    invitebutton,
    filterinput,
    post,
    postinput,
    roundcontent,
    asksayNav,
    askHoverImage,
    askSelectedImage,
    sayHoverImage,
    saySelectedImage,
    updateSelectedImage,
    updateHoverImage,
    tagHoverImage,
    tagSelectedImage,
    contributeContainer,
    asks,
    askprofilecontnet,
    askavatar,
    askprofilecontnetName,
    askprofilecontnetMessage,
    comunityProfileArrowIcon,
    loader,
    profileHover,
  } = useStyles();

  const location = useLocation();
  const history = useHistory();

  const [images, setImages] = useState({});
  const [selectedImage, setSelectedImage] = useState({});
  const [contributors, setContributors] = useState({});
  const [communityData, setCommunityData] = useState({});
  const [selectedId, setSelectedId] = useState("");
  const [feedData, setFeedData] = useState({});
  const [previewModal, setPreviewModal] = useState(false);
  const [contentType, setContentType] = useState("feed");
  const [filterPostType, setFilterPostType] = useState("");
  const [trendingAsks, setTrendingAsks] = useState([]);
  const [allTrendingAsks, setAllTrendingAsks] = useState({});
  const [selectedTagDetails, setSelectedTagDetails] = useState({});
  const [allTrendingTags, setAllTrendingTags] = useState({});
  const [trendingTags, setTrendingTags] = useState([]);
  const [page, setPage] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const listRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [saysId, setSaysId] = useState("");
  const [childSaysData, setChildSaysData] = useState([]);
  const [contributorBio, setContributorBio] = useState({});
  const [showBio, setShowBio] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isEnable, setIsEnable] = useState(null);
  const [isSignIn, setIsSignIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedLoading, setFeedLoading] = useState(false);
  const [childSayLoading, setChildSayLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [searchData, setSearchData] = useState({});
  const [invitesShow, setInvitesShow] = React.useState(false);
  const [invite, setInvite] = useState(null);
  const [selectedCommunity, setSelectedCommunity] = useState({});
  const [feedPageNumber, setFeedPageNumber] = useState(1);
  const [voteUpStatus, setVoteUpStatus] = useState({});
  const [followData, setFollowData] = useState({});
  const [hasRestrictionSays, setHasRestrictionSays] = useState(false);
  const [
    childAnsOrReplyRestrictionStatus,
    setChildAnsOrReplyRestrictionStatus,
  ] = useState("");
  const [asksToBeAnswered, setAsksToBeAnswered] = React.useState({});
  const [answersToYourAsk, setAnswersToYourAsk] = React.useState({});
  const [clearSearchHeader, setClearSearchHeader] = useState(false);
  const [communityType, setCommunityType] = useState("");
  const [open, setOpen] = React.useState(false);
  const [followReqMessage, setFollowReqMessage] = useState("");
  const [askOrSayFetchLoading, setAskOrSayFetchLoading] = useState(false);
  const [followSuccessModal, setFollowSuccessModal] = useState(false);
  const [afterFollowClose, setAfterFollowClose] = useState(null);

  const userDetails = useSelector((state) => state.SignInReducer?.userDetails);
  const commonModalContext = useContext(CommonModalContext);

  const { defaultCountry } = location.state || {};

  useEffect(() => {
    dispatch(fetchloginUser());
  }, []);

  useEffect(() => {
    const { signIn, tenantId, community, communityType } =
      location?.state || {};
    setIsEnable(signIn);
    setSelectedCommunity({
      tenantId: tenantId,
      tenantName: community || "",
    });
    setCommunityType(communityType);
  }, [location]);

  const isCommunityPrivate = useMemo(() => {
    return String(communityType).toLowerCase() === "private";
  }, [communityType]);

  const onHashTagClick = (hashTag) => {
    if (typeof hashTag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: hashTag.hashtag,
        tagActivityTenantId: hashTag.tenantId,
        isActionDisabled: isCommunityPrivate,
        onActionSuccess: handleActionSuccess,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag,
        isActionDisabled: isCommunityPrivate,
        onActionSuccess: handleActionSuccess,
      });
    }
  };

  const handleFollowedEmailCommunity = useCallback(async () => {
    const tenantId = location?.state?.tenantId;
    const tenantName = location?.state?.community;

    if (!tenantId || !tenantName) {
      return;
    }

    try {
      // NEW: fetch latest logged-in user data
      const response = await API.fetchLoginUser();
      const userDetails = response?.data;

      // NEW: get communities followed by current user
      const communityFollowNames =
        userDetails?.userData?.communityFollowNames || [];

      // NEW: check whether email community is already followed
      const isFollowing = communityFollowNames.some(
        (community) => Number(community?.id) === Number(tenantId),
      );

      if (isFollowing) {
        // NEW: switch to the community from email
        communityContext?.onChangeCommunity({
          tenantId: tenantId,
          tenantName: tenantName,
        });

        // NEW: go to Home
        history.push("/Home");
      }
    } catch (error) {
      console.error("Error checking followed community:", error);
    }
  }, [
    location?.state?.tenantId,
    location?.state?.community,
    communityContext,
    history,
  ]);

  useEffect(() => {
    handleFollowedEmailCommunity();
  }, [handleFollowedEmailCommunity]);

  const onInvitesSelction = (event) => {
    event.stopPropagation();
    setInvitesShow(true);
    setInvite(true);

    // Check if previewModal is currently open, then close it
    if (previewModal) {
      setPreviewModal(false);
    }
  };

  const fetchSearchData = async (params) => {
    setContentType("search");
    setSearchParam(params);
    setFeedLoading(true);
    try {
      const response = await API.getSearchData(params);
      setSearchData(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFeedLoading(false);
    }
  };

  const handleActionSuccess = (callback) => {
    setIsEnable(false);
    setAfterFollowClose(() => callback);
    setFollowSuccessModal(true);
  };

  const handleFollowSuccessModalClose = () => {
    setFollowSuccessModal(false);
    setIsEnable(false);
    dispatch(fetchloginUser());

    if (afterFollowClose) {
      afterFollowClose();
      setAfterFollowClose(null);
    }
  };

  const handleMakeDefault = async () => {
    let formdata = new FormData();
    formdata.append("userDefaultTenantId", location?.state?.tenantId);
    await API.setDefaultTenant(formdata)
      .then((res) => {
        console.log("handleMakeDefault res", res);
        setIsEnable(false);
        setIsSignIn(true);
        communityContext?.onChangeCommunity({
          tenantId: location?.state?.tenantId,
          tenantName: location?.state?.community,
        });
      })
      .catch((err) => {});
    history.push("/Home");
  };

  const handleFollow = async () => {
    let formdata = new FormData();
    formdata.append("communityID", location?.state?.tenantId);
    formdata.append("communityName", location?.state?.community);
    formdata.append("followStat", 1);
    formdata.append("sourceApp", "WebApp");
    await API.followUnfollowCommunity(formdata)
      .then((res) => {
        console.log("handleMakeFollowUnfollow res", res);
        setIsEnable(false);
        setIsSignIn(true);
        communityContext?.onChangeCommunity({
          tenantId: location?.state?.tenantId,
          tenantName: location?.state?.community,
        });
      })
      .catch((err) => {});
    history.push("/Home");
  };

  const fetchCommunityData = async () => {
    await axios
      .request({
        url: `${baseURL}/jsonindex/community-url?src=inviteLink&tid=${
          location?.state?.tenantId
        }&id=${"Z2Vmb3lpNDMzOEBmcmFuZGluLmNvbQ=="}`,
        method: "Get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Set-Cookie": Cookies.get("JSESSIONID"),
        },
        withCredentials: true,
      })
      .then((res) => {
        setCommunityData(res);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchParamApi();
      fetchAllFeed();
      fetchContributeApi();
      fetchTrendingAsks();
      fetchTrendingTags();
    }, 500);

    if (!location?.state?.signIn) {
      fetchCommunityData();
    }
  }, [location?.state?.signIn]);

  const fetchContributeApi = async () => {
    try {
      const res = await API.fetchContributors();
      setContributors(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchParamApi = async () => {
    await axios
      .get(`${baseURL}/jsonindex/main?logParam=restrict`)
      .then((res) => {
        setImages(res?.data);
      });
  };

  const filterPosts = (filterType) => {
    setFilterPostType(filterType);
    fetchAllFeed(filterType);
  };

  const fetchAllFeed = async (filterType) => {
    setFeedLoading(true);
    const newPageNumber = (feedPageNumber - 1) * 10;
    try {
      const response = await API.fetchFeedData(filterType, newPageNumber);
      setFeedData(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFeedLoading(false);
    }
  };

  const setShowData = (contentType) => {
    let copiedContentType = contentType;
    //if there is need to display singleTrendingTag then remove if condition
    // if (contentType === "singleTrendingTag") {
    //   copiedContentType = "tag";
    // }

    if (copiedContentType === "ask") {
      fetchAllAsks();
    } else if (copiedContentType === "tag") {
      fetchAllTags();
    }
    setContentType(copiedContentType);
  };

  const fetchAllTags = async () => {
    setFeedLoading(true);
    try {
      const response = await API.fetchAllTags(0);
      setAllTrendingTags(response.data || {});
    } catch (e) {
      console.error(e);
    } finally {
      setFeedLoading(false);
    }
  };

  const fetchAllAsks = async () => {
    setFeedLoading(true);
    try {
      const response = await API.fetchAllAsks(0);
      setAllTrendingAsks(response.data || {});
    } catch (e) {
      console.error(e);
    } finally {
      setFeedLoading(false);
    }
  };

  const fetchSelectedTagDetails = async (tagId) => {
    try {
      const tenantId = selectedCommunity?.tenantId;
      const response = await API.fetchTagDetails(tenantId, tagId);
      setSelectedTagDetails(response?.data || {});
    } catch (e) {
      console.error("Error fetching tag details:", e);
    }
  };

  const fetchTrendingTags = async () => {
    try {
      const response = await API.fetchTrendingTags();
      setTrendingTags(response?.data?.trendingTags || []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchTrendingAsks = async () => {
    try {
      const response = await API.fetchTrendingAsks();
      setTrendingAsks(response?.data?.trendingAsks || []);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (communityData?.status === 200) {
      setTimeout(() => {
        setIsFetching(false);
      }, 5000);
    }
  }, [communityData]);

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;
    if (scrollTop + clientHeight === scrollHeight) {
      setIsFetching(true);
      setIsClicked(true);
      setPage(page + 10);
    }
  };

  useEffect(() => {
    const obj = images?.communities?.find(
      (item) => item?.id === location?.state?.tenantId,
    );
    setSelectedImage(obj);
  }, [images]);

  useEffect(() => {
    fetchAllFeed(filterPostType);
  }, [filterPostType, feedPageNumber]);

  // const onCommunityChange = async (id, name) => {
  //   setFeedPageNumber(1);
  //   setFeedData({});
  //   if (selectedCommunity && selectedCommunity.id !== id) {
  //     try {
  //       const response = await API.changeCommunity(name, id);
  //       setSelectedCommunity({
  //         tenantId: id,
  //         tenantName: name || "",
  //       });
  //       if (response) {
  //         fetchAllFeed();
  //         if (
  //           contentType === "tag" ||
  //           contentType === "ask" ||
  //           contentType === "search"
  //         ) {
  //           setContentType("feed");
  //         }
  //         fetchContributeApi();
  //         fetchTrendingAsks();
  //         fetchTrendingTags();
  //         dispatch(fetchloginUser());
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }
  //     window.scrollTo(0, 0);
  //   }
  // };

  const onCommunityChange = async (id, name) => {
    // navigate to Home page and update communityContext to change community in home page when switch to already following community in view activity
    communityContext?.onChangeCommunity({
      tenantId: id,
      tenantName: name,
    });
    history.push("/");
  };
  const handleFilterClick = (filterType) => {
    setSaysId(""); //reset says id
    setFeedPageNumber(1); //reset pageNumber
    setFilterPostType(filterPostType === filterType ? "" : filterType);
  };

  const showPreview = (e) => {
    setPreviewModal(!previewModal);
  };

  const handleSeeAll = (id) => {
    setContentType(id);
    setSelectedId("");
  };

  const handleBack = () => {
    setContentType("feed");
    setPage(0);
    setClearSearchHeader(true);
    // fetchAskApi();
    // fetchTagsApi();
  };

  const handleBackArrow = () => {
    // If the user arrived here from an email action,
    // return directly to Home instead of the Communities page.
    if (location?.state?.fromEmailAction) {
      history.push("/Home");
      return;
    }
    history.push("/communities", {
      countryCode: location?.state?.countryCode,
      previousCountry: defaultCountry,
    });
  };

  const handleSayClick = async (e, id) => {
    e.preventDefault();
    if (saysId === id) {
      setSaysId("");
    } else {
      setSaysId(id);
      try {
        setChildSayLoading(true);
        let formdata = new FormData();
        formdata.append("id", id);
        formdata.append("in_pop_columns", "all");
        formdata.append("in_limit", 0);
        const res = await axios.post(
          `${baseURL}/jsonuser/child-says`,
          formdata,
        );
        setChildSaysData(res?.data);
      } catch (e) {
        console.error(e);
      } finally {
        setChildSayLoading(false);
      }
    }
  };

  const handleClickEvent = (id, showBio) => {
    const data = contributors?.contribut.find((item) => {
      return item?.id === id;
    });
    setContributorBio(data);
    setShowBio(showBio);
  };

  const onUpdateSelection = (type) => {
    if (isCommunityPrivate) return;
    setModalShow(true);
    setModalType(type);
  };

  const onHideUpdateModal = () => {
    setModalShow(false);
  };

  const onModalSelect = () => {
    setModalShow(false);
  };

  const handleClose = () => {
    setIsEnable(false);
    setIsSignIn(true);
  };

  const deleteMessage = async (id, type, Parent_ID) => {
    console.log("Inside deleteMessage", id, type, Parent_ID);
    try {
      const response = await API.deleteMessage(id);
      if (response) {
        if (isChildSayMessageType(type)) {
          console.log("childSaysData", childSaysData);
          const updatedData = childSaysData.childSAYsMessageList.filter(
            (each) => each.id !== id,
          );
          setChildSaysData({
            ...childSaysData,
            childSAYsMessageList: updatedData,
          });
          if (contentType === "tag" || contentType === "singleTrendingTag") {
            updateTrendingTagData(Parent_ID, "minus");
          } else if (contentType === "ask") {
            updateTrendingAskData(Parent_ID, "minus");
          } else if (contentType === "search") {
            updateSearchData(Parent_ID, "minus");
          } else {
            updateFeedData(Parent_ID, "minus");
          }
        } else {
          if (contentType === "feed") {
            const newData = [...feedData.feed];
            const modifiedData = newData.filter((each) => each.id !== id);
            const updatedFeedData = {
              ...feedData,
              breadCountLength: modifiedData.length,
              feed: [...modifiedData],
            };
            setFeedData(updatedFeedData);
          } else if (contentType === "ask") {
            const newData = [...allTrendingAsks?.trendingAsks];
            const modifiedData = newData.filter((each) => each.id !== id);
            setAllTrendingAsks(modifiedData);
          } else if (contentType === "tag") {
            const newData = [...allTrendingTags.trendingTags];
            const modifiedData = newData.filter((each) => each.id !== id);
            setAllTrendingTags(modifiedData);
          } else if (contentType === "search") {
            const newData = [...searchData.messageList];
            const modifiedData = newData.filter((each) => each.id !== id);
            setSearchData({
              ...searchData,
              totalList: modifiedData.length,
              messageList: modifiedData,
            });
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const updateFeedData = (id, operator) => {
    // updating sayCount in the list based on operator
    // operator = 'add' | 'minus'
    const feed = feedData?.feed || [];
    const copiedFeed = [...feed];
    const updatedFeed = copiedFeed.map((eachFeed) => {
      const isMatch = String(eachFeed?.id) === String(id);
      const currentCount = Number(eachFeed?.sayCount) || 0;
      const sayCount = isMatch
        ? operator === "add"
          ? currentCount + 1
          : Math.max(0, currentCount - 1)
        : eachFeed.sayCount;
      return {
        ...eachFeed,
        sayCount,
      };
    });
    const updatedFeedData = { ...feedData, feed: updatedFeed };
    setFeedData(updatedFeedData);
  };

  const updateSearchData = (id, operator) => {
    // updating sayCount in the list based on operator
    // operator = 'add' | 'minus'
    const searchFeed = [...searchData.messageList] || [];
    const updatedSearchFeed = searchFeed.map((eachFeed) => {
      const isMatch = String(eachFeed?.id) === String(id);
      const currentCount = Number(eachFeed?.sayCount) || 0;
      const sayCount = isMatch
        ? operator === "add"
          ? currentCount + 1
          : Math.max(0, currentCount - 1)
        : eachFeed.sayCount;
      return {
        ...eachFeed,
        sayCount: sayCount,
      };
    });
    const updatedData = { ...searchData, messageList: [...updatedSearchFeed] };
    setSearchData(updatedData);
  };

  const handleCloseMsgRequestAlert = () => {
    setOpen(false);
  };

  const requestToFollow = (id) => {
    const formData = new FormData();
    formData.append("tenantId", id);

    API.requestToFollow(formData)
      .then((res) => {
        if (res?.data?.status) {
          setFollowReqMessage(
            `${res.data.status}. You will be notified once the moderator has approved your request.`,
          );
          setOpen(true);
        } else {
          setFollowReqMessage("Unexpected response from server.");
          setOpen(true);
        }
      })
      .catch((err) => {
        console.error("Error in requestToFollow:", err);
        setFollowReqMessage("Failed to send follow request. Please try again.");
        setOpen(true);
      });
  };

  //update trending tags or trendingSingle tag
  const updateTrendingTagData = (id, operator) => {
    // updating sayCount is the list based on operator
    // operator = 'add' | 'minus'
    const copiedTags =
      contentType === "singleTrendingTag"
        ? [...selectedTagDetails?.messageList]
        : [...allTrendingTags?.trendingTags];
    const updatedTags = copiedTags.map((eachTag) => {
      const sayCount =
        eachTag?.id === id
          ? operator === "add"
            ? eachTag?.sayCount + 1
            : eachTag?.sayCount - 1
          : eachTag.sayCount;
      return {
        ...eachTag,
        sayCount,
      };
    });

    if (contentType === "singleTrendingTag") {
      setSelectedTagDetails({
        ...selectedTagDetails,
        messageList: [...updatedTags],
      });
    } else {
      setAllTrendingTags({
        ...allTrendingTags,
        trendingTags: [...updatedTags],
      });
    }
  };

  //update trending asks
  const updateTrendingAskData = (id, operator) => {
    // updating sayCount is the list based on operator
    // operator = 'add' | 'minus'
    const copiedAsks = [...allTrendingAsks?.trendingAsks];
    const updatedAsks = copiedAsks.map((eachAsk) => {
      const sayCount =
        eachAsk?.id === id
          ? operator === "add"
            ? eachAsk?.sayCount + 1
            : eachAsk?.sayCount - 1
          : eachAsk.sayCount;
      return {
        ...eachAsk,
        sayCount,
      };
    });
    setAllTrendingAsks({ ...allTrendingAsks, trendingAsks: [...updatedAsks] });
  };

  const refreshFeedData = (isChildPost, id) => {
    console.log("refreshFeedData", contentType, id, isChildPost);
    if (contentType === "feed") {
      if (isChildPost) {
        fetchChildSaysData(id);
      } else {
        fetchAllFeed(filterPostType);
      }
    } else if (contentType === "tag") {
      if (isChildPost) {
        fetchChildSaysData(id);
      } else {
        fetchAllTags();
      }
    } else if (contentType === "ask") {
      if (isChildPost) {
        fetchChildSaysData(id);
      } else {
        fetchAllAsks();
      }
    } else if (contentType === "search") {
      if (isChildPost) {
        fetchChildSaysData(id);
      } else {
        fetchSearchData(searchParam);
      }
    }
  };

  const fetchChildSaysData = async (id, popCols, limit) => {
    setChildSayLoading(true);
    try {
      const response = await API.fetchChildSaysData(id, popCols, limit);
      setChildSaysData(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setChildSayLoading(false);
    }
  };

  const fetchVoteUpStatus = async (id, status) => {
    try {
      const response = await API.fetchVoteUpStatus(id, status);
      setVoteUpStatus(response.data);
      if (response?.data?.justFollowed) {
        handleActionSuccess(() => {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleFollowunfollow = async (id, status) => {
    try {
      const response = await API.fetchFollowUnfollowData(id, status);
      setFollowData(response.data);
      if (response?.data?.justFollowed) {
        handleActionSuccess(() => {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const postChildSayData = async (id, msg, lnglat, locSelect, attachment) => {
    try {
      const formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.postChildSayData(
        id,
        formdata,
        lnglat,
        locSelect,
      );
      const status = response?.data?.status || "";
      if (status === "New Hash") {
        return "New Hash";
      }

      if (response?.data?.justFollowed) {
        handleActionSuccess?.(() => {
          // Newly added: Show restriction popup after follow success popup is closed.
          if (status === "E_Say" || status === "E") {
            setHasRestrictionSays(true);
            setChildAnsOrReplyRestrictionStatus(status);
          }
        });
        if (status !== "E_Say" && status !== "E") {
          fetchChildSaysData(id);
          if (contentType === "tag" || contentType === "singleTrendingTag") {
            updateTrendingTagData(id, "add");
          } else if (contentType === "ask") {
            updateTrendingAskData(id, "add");
          } else if (contentType === "search") {
            updateSearchData(id, "add");
          } else {
            updateFeedData(id, "add");
          }
        }
        return status;
      } else if (status === "E_Say" || status === "E") {
        setHasRestrictionSays(true);
        setChildAnsOrReplyRestrictionStatus(status);
        return status;
      } else {
        fetchChildSaysData(id);
        if (contentType === "tag" || contentType === "singleTrendingTag") {
          updateTrendingTagData(id, "add");
        } else if (contentType === "ask") {
          updateTrendingAskData(id, "add");
        } else if (contentType === "search") {
          updateSearchData(id, "add");
        } else {
          updateFeedData(id, "add");
        }
        return status;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const clearAsksAndSays = () => {
    setAsksToBeAnswered({});
    setAnswersToYourAsk({});
  };

  const getSaysListDataForAsks = async (page, id) => {
    try {
      const formdata = new FormData();
      formdata.append("id", id);
      const response = await API.fetchAsksSearchResultData(page, formdata);
      return response?.data?.messageList;
    } catch (e) {
      console.error(e);
    }
  };

  const getAskListDataForSays = async (page, messageId) => {
    try {
      const formData = new FormData();
      formData.append("messageID", messageId);
      const response = await API.fetchAskListData(page, formData);
      return response?.data?.messageList;
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSaysDataForAsks = async (
    msg,
    latLong,
    locSelection,
    postingOption,
    attachment,
  ) => {
    try {
      setAskOrSayFetchLoading(true);
      const formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.fetchAsksData(
        formdata,
        latLong,
        locSelection,
        postingOption,
      );
      const possibleAnsList = await getSaysListDataForAsks(
        0,
        response?.data?.messageConnectionID,
      );
      // Backend removed messageList from fetchAsksData API.
      // Fetching it separately from fetchAsksSearchResultData
      // and attaching it to maintain existing UI behavior.
      // Pagination support will be added later.
      response.data.messageList = possibleAnsList || [];

      setAnswersToYourAsk(response.data || {});
      setAskOrSayFetchLoading(false);
      if (response?.data?.justFollowed) {
        handleActionSuccess();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchAsksToAnswer = async (
    msg,
    latLong,
    locSelection,
    postingOption,
    attachment,
  ) => {
    try {
      setAskOrSayFetchLoading(true);
      const formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.fetchSaysData(
        formdata,
        latLong,
        locSelection,
        postingOption,
      );

      const possibleAskList = await getAskListDataForSays(
        0,
        response?.data?.messageId,
      );
      if (response?.data?.justFollowed) {
        handleActionSuccess(() => {
          if (
            response?.data?.tenantSayStatus === "E" &&
            possibleAskList?.length === 0
          ) {
            setChildAnsOrReplyRestrictionStatus("SAY");
            setHasRestrictionSays(true);
          }
        });
      } else if (
        response?.data?.tenantSayStatus === "E" &&
        possibleAskList?.length === 0
      ) {
        // Existing behavior when no follow popup is required
        setChildAnsOrReplyRestrictionStatus("SAY");
        setHasRestrictionSays(true);
      }
      // Backend removed messageList from fetchSaysData API.
      // Fetching it separately from success-say API and attaching it
      // to maintain existing UI behavior.
      // Pagination support will be added later.
      response.data.messageList = possibleAskList || [];
      setAsksToBeAnswered(response.data || {});
      setAskOrSayFetchLoading(false);
      filterPosts("");
    } catch (e) {
      console.error(e);
    }
  };

  const askYourCommunity = async (id) => {
    try {
      const res = await API.askYourCommunity(id);
      return res;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const deleteAnswersToAsksDialogPost = (id) => {
    const newAnswersToYourAsksList = answersToYourAsk?.messageList?.filter(
      (item) => item.id !== id,
    );

    // Update the state correctly
    setAnswersToYourAsk({
      ...answersToYourAsk, // Spread the existing answersToYourAsk properties
      messageList: newAnswersToYourAsksList, // Update the messageList with the filtered list
    });
  };

  const deleteAsksToBeAnsweredDialogPost = (id) => {
    const newAnswersToYourAsksList = asksToBeAnswered?.messageList?.filter(
      (item) => item.id !== id,
    );

    // Update the state correctly
    setAsksToBeAnswered({
      ...asksToBeAnswered, // Spread the existing answersToYourAsk properties
      messageList: newAnswersToYourAsksList, // Update the messageList with the filtered list
    });
  };

  const onSkopicClick = async () => {
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId,
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Page
      fetchSearchData={fetchSearchData}
      clearSearchHeader={clearSearchHeader}
      onSkopicClick={onSkopicClick}
      pageType={"viewActivity"}
      onClickHashTag={onHashTagClick}
    >
      {isLoading ? (
        <CircularProgress className={loader} />
      ) : (
        <React.Fragment>
          <div className="container">
            <div
              className={`row ${layoutStyles.rowContainer}`}
              style={{ marginBottom: isEnable ? "110px" : "5px" }}
            >
              <div className={`col-lg-3 ${layoutStyles.leftside}`}>
                <LeftSideBar
                  onCommunityChange={onCommunityChange}
                  setShowData={() => {}}
                  selectedCommunity={selectedCommunity}
                  disableCommunityChange={false}
                  hideFooter={false}
                  viewActivity={true}
                />
              </div>
              <div
                className={`col-lg-6 ${layoutStyles.middle}`}
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                {contentType === "feed" ? (
                  <>
                    <div className={feed}>
                      {userDetails?.userData?.viewActivityUserTenantInfo
                        ?.tenantLogo ? (
                        <img
                          src={
                            userDetails?.userData?.viewActivityUserTenantInfo
                              ?.tenantLogo
                              ? `${imageServerURL}${userDetails?.userData?.viewActivityUserTenantInfo?.tenantLogo}`
                              : process.env.REACT_APP_DUMMY_COMMUNITY_IMAGE
                          }
                          alt="community banner"
                          onClick={(e) => showPreview(e)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",
                            borderRadius: "26px",
                            display: "block",
                            cursor: "pointer",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : null}
                      <div className={container}>
                        <div className={moderator}>
                          {userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantName && (
                            <>
                              <p
                                onClick={(e) => showPreview(e)}
                                style={{
                                  fontSize: "20px",
                                  color: "#373334",
                                  margin: 0,
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "90%",
                                }}
                              >
                                {
                                  userDetails?.userData
                                    ?.viewActivityUserTenantInfo?.tenantName
                                }
                              </p>
                              <MdOutlineArrowForwardIos
                                className={comunityProfileArrowIcon}
                                style={{ cursor: "pointer" }}
                                onClick={(e) => showPreview(e)}
                              />
                            </>
                          )}
                        </div>
                        <div className={prospectimagesdiv}>
                          <a
                            className={invitebutton}
                            onClick={onInvitesSelction}
                            style={{ cursor: "not-allowed" }}
                          >
                            <UserAddSvg />
                            Invite Members
                          </a>
                        </div>
                      </div>
                      <PhotoPreview
                        open={previewModal}
                        handleClose={() => setPreviewModal(false)}
                        tenantId={location?.state?.tenantId}
                        communityImage={
                          userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantLogo
                        }
                        communityDescription={
                          userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantDescription
                        }
                        communityName={
                          userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantName
                        }
                        tenantlatitude={
                          userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantlatitude
                        }
                        tenantlongitude={
                          userDetails?.userData?.viewActivityUserTenantInfo
                            ?.tenantlongitude
                        }
                        communityAddress={""}
                      />
                    </div>
                    <div>
                      <div className={filterinput}>
                        <SayAskPost
                          isSignIn={isSignIn}
                          isDisabled={isCommunityPrivate}
                          asksToBeAnswered={asksToBeAnswered}
                          answersToYourAsk={answersToYourAsk}
                          childSaysData={childSaysData}
                          clearAsksAndSays={clearAsksAndSays}
                          fetchSaysDataForAsks={fetchSaysDataForAsks}
                          fetchAsksToAnswer={fetchAsksToAnswer}
                          askYourCommunity={askYourCommunity}
                          fetchFeedData={fetchAllFeed}
                          fetchChildSaysData={fetchChildSaysData}
                          postChildSayData={postChildSayData}
                          deleteMessage={deleteMessage}
                          filterPosts={filterPosts}
                          fetchFollowData={handleFollowunfollow}
                          fetchVoteUpStatus={fetchVoteUpStatus}
                          deleteAnswersToAsksDialogPost={
                            deleteAnswersToAsksDialogPost
                          }
                          deleteAsksToBeAnsweredDialogPost={
                            deleteAsksToBeAnsweredDialogPost
                          }
                          onHashTagClick={onHashTagClick}
                          pageType={"viewActivityAfterSignIn"}
                          askOrSayFetchLoading={askOrSayFetchLoading}
                          onActionSuccess={handleActionSuccess}
                        />
                        <div className={roundcontent}>
                          <div className={asksayNav}>
                            <ul>
                              <li
                                onClick={() => handleFilterClick("ask")}
                                className={
                                  filterPostType === "ask"
                                    ? askHoverImage
                                    : askSelectedImage
                                }
                              >
                                <a>
                                  <span>Ask</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleFilterClick("say")}
                                className={
                                  filterPostType === "say"
                                    ? sayHoverImage
                                    : saySelectedImage
                                }
                              >
                                <a>
                                  <span>Say</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleFilterClick("update")}
                                className={
                                  filterPostType === "update"
                                    ? updateHoverImage
                                    : updateSelectedImage
                                }
                              >
                                <a>
                                  <span>Update</span>
                                </a>
                              </li>
                              <li
                                onClick={() => handleFilterClick("hashtag")}
                                className={
                                  filterPostType === "hashtag"
                                    ? tagHoverImage
                                    : tagSelectedImage
                                }
                              >
                                <a>
                                  <span>Tag</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          background: "#E5E4E2",
                          border: "1px solid #DEE0E1",
                          borderRadius: "20px 0 0 0",
                          padding: "10px 20px 0 20px",
                          height: "calc(100vh - 90px)",
                          overflowY: "scroll",
                          scrollbarWidth: "thin",
                        }}
                        onScroll={handleScroll}
                        ref={listRef}
                      >
                        <Feed
                          data={feedData?.feed || []}
                          id={saysId}
                          childSaysData={childSaysData}
                          childSayLoading={childSayLoading}
                          feedLoading={feedLoading}
                          filterType={filterPostType}
                          handleFollowunfollow={handleFollowunfollow}
                          handleSayClick={handleSayClick}
                          deleteMessage={deleteMessage}
                          refreshFeedData={refreshFeedData}
                          fetchVoteUpStatus={fetchVoteUpStatus}
                          postChildSayData={postChildSayData}
                          fetchChildSaysData={fetchChildSaysData}
                          flow="afterSignIn"
                          feedPageNumber={feedPageNumber}
                          onHashTagClick={onHashTagClick}
                          isActionDisabled={isCommunityPrivate ?? false}
                          onActionSuccess={handleActionSuccess}
                        />
                      </div>
                    </div>
                  </>
                ) : contentType === "search" ? (
                  <SearchResultBeforeLogin
                    loading={feedLoading}
                    searchData={searchData}
                    handleBack={handleBack}
                    childSaysData={childSaysData}
                    fetchChildSaysData={fetchChildSaysData}
                    postChildSayData={postChildSayData}
                    fetchFollowData={handleFollowunfollow}
                    fetchVoteUpStatus={fetchVoteUpStatus}
                    fetchFeedData={fetchAllFeed}
                    deleteMessage={deleteMessage}
                    refreshFeedData={refreshFeedData}
                    onHashTagClick={onHashTagClick}
                    isActionDisabled={isCommunityPrivate ?? false}
                  />
                ) : contentType === "ask" ? (
                  <TrendingAsks
                    loading={feedLoading}
                    childSaysLoading={childSayLoading}
                    postChildSayData={postChildSayData}
                    fetchFeedData={fetchAllFeed}
                    allAsks={allTrendingAsks?.trendingAsks || []}
                    // allAsks={allTrendingAsks}
                    goBack={handleBack}
                    childSaysData={childSaysData}
                    fetchChildSaysData={fetchChildSaysData}
                    deleteMessage={deleteMessage}
                    fetchFollowData={handleFollowunfollow}
                    fetchVoteUpStatus={fetchVoteUpStatus}
                    refreshFeedData={refreshFeedData}
                    showData={contentType}
                    onHashTagClick={onHashTagClick}
                    isActionDisabled={isCommunityPrivate ?? false}
                    flow={"afterSignIn"}
                    onActionSuccess={handleActionSuccess}
                  />
                ) : contentType === "tag" ? (
                  <TrendingTags
                    loading={feedLoading}
                    childSaysLoading={childSayLoading}
                    postChildSayData={postChildSayData}
                    fetchFeedData={fetchAllFeed}
                    allTags={allTrendingTags?.trendingTags || []}
                    allTagData={allTrendingTags}
                    goBack={handleBack}
                    childSaysData={childSaysData}
                    fetchChildSaysData={fetchChildSaysData}
                    deleteMessage={deleteMessage}
                    fetchFollowData={handleFollowunfollow}
                    fetchVoteUpStatus={fetchVoteUpStatus}
                    refreshFeedData={refreshFeedData}
                    showData={contentType}
                    onHashTagClick={onHashTagClick}
                    isActionDisabled={isCommunityPrivate ?? false}
                    flow={"afterSignIn"}
                    onActionSuccess={handleActionSuccess}
                  />
                ) : contentType === "singleTrendingTag" ? (
                  <SingleTrendingTag
                    loading={feedLoading}
                    childSaysLoading={childSayLoading}
                    postChildSayData={postChildSayData}
                    fetchFeedData={fetchAllFeed}
                    allTags={selectedTagDetails?.messageList || []}
                    goBack={handleBack}
                    childSaysData={childSaysData}
                    fetchChildSaysData={fetchChildSaysData}
                    deleteMessage={deleteMessage}
                    fetchFollowData={handleFollowunfollow}
                    fetchVoteUpStatus={fetchVoteUpStatus}
                    refreshFeedData={refreshFeedData}
                    showData={contentType}
                    onHashTagClick={onHashTagClick}
                    isActionDisabled={isCommunityPrivate ?? false}
                    onActionSuccess={handleActionSuccess}
                  />
                ) : null}
              </div>
              <div className={`col-lg-3 ${layoutStyles.rightside}`}>
                <RightSideBar
                  contributorsData={contributors}
                  trendingTags={trendingTags}
                  trendingAsks={trendingAsks}
                  setShowData={setShowData}
                  showModal={modalShow}
                  modalType={modalType}
                  fetchSelectedTagDetails={fetchSelectedTagDetails}
                  onUpdateSelection={onUpdateSelection}
                  hideUpdateModal={onHideUpdateModal}
                  fetchFeedData={fetchAllFeed}
                  filterPosts={filterPosts}
                  isDisabled={isCommunityPrivate}
                  selectedCommunity={selectedCommunity}
                  isActionDisabled={isCommunityPrivate ?? false}
                  pageType={"viewActivityAfterSignIn"}
                  onActionSuccess={handleActionSuccess}
                />
              </div>
            </div>
          </div>

          {isEnable && (
            <Grid
              container
              style={{
                padding: "10px",
                background: "#4795DE",
                position: "fixed",
                bottom: 0,
                zIndex: 1,
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "16px",
                  fontWeight: "bold",
                  position: "relative",
                }}
              >
                <div onClick={handleBackArrow} style={{ paddingRight: "10px" }}>
                  <ArrowCircleLeftIcon style={{ fill: "#ffffff" }} />
                </div>
                {selectedImage?.type === "private" && (
                  <p>Request to follow to engage in this Community</p>
                )}
                {(selectedImage?.type === "Public" ||
                  selectedImage?.type === "public") && (
                  <p>
                    Select Follow or Make Default to engage in this Community
                  </p>
                )}
                <Box position="absolute" right={0}>
                  <IconButton onClick={() => setIsEnable(false)}>
                    <IoIosCloseCircleOutline color="white" />
                  </IconButton>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "10px",
                }}
              >
                <div
                  className={buttonContainer}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {selectedImage?.type?.toLowerCase() === "public" ? (
                    <>
                      <Button variant="contained" onClick={handleFollow}>
                        Follow
                      </Button>
                      <div style={{ padding: "0 20px", color: "#ffffff" }}>
                        or
                      </div>
                      <Button variant="contained" onClick={handleMakeDefault}>
                        Make Default
                      </Button>
                    </>
                  ) : selectedImage?.type?.toLowerCase() === "private" ? (
                    <Button
                      variant="contained"
                      onClick={() => requestToFollow(selectedImage?.id)}
                    >
                      Request to Follow
                    </Button>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          )}

          <Modal
            open={followSuccessModal}
            onClose={handleFollowSuccessModalClose}
            aria-labelledby="follow-success-modal-title"
            sx={{
              zIndex: 12000,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                maxWidth: "90%",
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: 24,
                p: 3,
                outline: "none",
              }}
            >
              <IconButton
                onClick={handleFollowSuccessModalClose}
                sx={{
                  position: "absolute !important",
                  top: "8px !important",
                  right: "8px !important",
                  left: "auto !important",
                  bottom: "auto !important",
                  zIndex: 10,
                }}
              >
                <IoIosCloseCircleOutline />
              </IconButton>

              <Box
                id="follow-success-modal-title"
                sx={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: 600,
                  padding: "20px 30px 15px",
                }}
              >
                You are now following{" "}
                {selectedCommunity?.tenantName ||
                  location?.state?.community ||
                  userDetails?.userData?.viewActivityUserTenantInfo?.tenantName}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleFollowSuccessModalClose}
                  sx={{
                    backgroundColor: "#1976d2 !important",
                    color: "#ffffff !important",
                    textTransform: "uppercase",
                    fontWeight: 600,
                    fontSize: "14px",
                    padding: "6px 24px",
                    borderRadius: "4px",
                    boxShadow:
                      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important",
                    "&:hover": {
                      backgroundColor: "#1565c0 !important",
                    },
                  }}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Modal>

          {hasRestrictionSays && (
            <RestrictionMsgModal
              open={hasRestrictionSays}
              onClose={() => setHasRestrictionSays(false)}
              title="Thank you"
              message={`Your ${
                childAnsOrReplyRestrictionStatus === "E"
                  ? "Reply"
                  : childAnsOrReplyRestrictionStatus === "E_Say"
                  ? "Answer"
                  : childAnsOrReplyRestrictionStatus
              } will publish as soon as the Community Moderator approves it.`}
            />
          )}
          <Dialog onClose={handleCloseMsgRequestAlert} open={open}>
            <DialogContent>
              <p>{followReqMessage}</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseMsgRequestAlert} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      )}
    </Page>
  );
};

export default ViewActivitySignIn;
